import React, { Component } from "react";
import { Button, Form, Modal, Tooltip } from "antd";
// Row
import CloseIcon from "../../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  // extensionValidateDownload,
  extValidateDownload,
  uuidv4,
  MAX_SIZE_DOWNLOAD_ZIP_FOLDER,
  ENDPOINT } from '../../../utils/index';
// getFileExtension
import SVGView from '../../assets-view/SVGView';
import { VideoView } from '../../assets-view/VideoView';
import DocumentView from '../../document-view/DocumentView';
import fileextension from 'file-extension';
import {
    startDownload,
} from '../../../actions/DownloadAction'
import "./DownloadModal.css";
import Socket from '../../../utils/sockets'
import { setkeyboardEnabled } from "../../../actions/AppAction";
import '../../../components/assets-download/download-asset.css'
import BunkeyAPI from '../../../api/BunkeyAPI'
import axios from 'axios'
import jwtDecode from 'jwt-decode'
import queryString from 'query-string'
import moment from 'moment'

class DownloadModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      targetFolderId: null,
      folderId: props.selectedFile._id,
      extValidate: false,
      accessToken: null,
      disabledBtnOriginal: false 
    };
  }
  componentDidMount() {
    const { selectedFile } = this.props
    // let ext = extensionValidateDownload(selectedFile.originalURL)
    let ext = extValidateDownload(selectedFile.originalURL, selectedFile);
    let disabledBtn = this.handleDisabledOriginal(selectedFile);
    this.setState({
      extValidate: ext,
      disabledBtnOriginal: disabledBtn
    });
    this.props.setkeyboardEnabled(true)
    const { wc } = this.props
    let qs = queryString.parse(this.props.location.search)

    if (!wc) {
      const { webToken } = qs

      if (webToken) {
        axios
          .post(`${ENDPOINT}shared/validate`, { webToken })
          .then(resp => {
            const accessToken = resp.data.acssTkn
              ? resp.data.acssTkn
              : resp.data.accessToken
            const decode = jwtDecode(accessToken)
            const client = decode.user.client
            this.setState({ client, accessToken })
          })
          .catch(() => { })
      }
    }
  }
  handleOnDownload = async (quality, multiple = false) => {
    // Flujo socket + Lambda (el que estaba antes del "new download service").
    // startDownloadV2 pegaba a /v1/downloads-services, que en el gateway hace proxy a
    // http://localhost:3084: en produccion no hay nada escuchando ahi y toda descarga
    // moria en 500. Se vuelve a esto hasta que ese servicio este desplegado de verdad.
    const { workclient, selectedFile, intl } = this.props;
    const { accessToken } = this.state;
    const uuid = uuidv4();
    const id = selectedFile._id;
    this.props.startDownload({
      id: selectedFile._id,
      uuid: uuid,
      name: selectedFile.name,
      state: 'download_in_progress',
      client: !workclient
        ? selectedFile.client
        : workclient,
      quality,
    });
    let fileSize;
    if (!workclient) {
      const resp = await axios.get(`${ENDPOINT}downloads/get-sizes?id=${id}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        }
      });
      if(!resp.data) return;
      fileSize = resp.data[0].fileSize;
    }else{
      const resp = await BunkeyAPI({
        url: `/downloads/get-sizes?id=${id}`,
        method: 'GET',
      });
      if(!resp.data) return;
      fileSize = resp.data[0].fileSize;
    }
    const toZip = fileSize > MAX_SIZE_DOWNLOAD_ZIP_FOLDER;
    Socket.getInstance().emit(
      toZip
        ? 'request_client_download_not_zip_folder'
        : 'request_client_download'
    ,{
      wc: !workclient
        ? selectedFile.client._id === undefined
          ? selectedFile.client
          : selectedFile.client._id
        : workclient,
      quality,
      asset: selectedFile._id,
      uuid,
      lang: intl.locale,
      channel: 'single',
    });
    this.props.handleHiddenModal();
  }
  handleDisabledOriginal = (itemSelected) => {
    if (moment().format("YYYY-MM-DD") > moment(itemSelected.metadata.dueDate).utc().format("YYYY-MM-DD") && itemSelected.metadata.createdDate !== null && itemSelected.metadata.createdDate !== '') {
      return true
    } else if (moment(itemSelected.metadata.createdDate).utc().format("YYYY-MM-DD") > moment().format("YYYY-MM-DD")
      && moment().format("YYYY-MM-DD") < moment(itemSelected.metadata.dueDate).utc().format("YYYY-MM-DD")
      && itemSelected.metadata.createdDate !== null && itemSelected.metadata.createdDate !== '') {
        return true
    } else {
      return false
    }
    
  }

  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
      selectedFile,
      // isInFolderAction,
      // showIconExclamation,
      dataDownload,
      newColor
    } = this.props;

    const isBunker = selectedFile.type === "folder" || selectedFile.type === "bunker";
    const alreadyDownloading = dataDownload.find(f => f.id === selectedFile._id) !== undefined
    const { extValidate, disabledBtnOriginal } = this.state

    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="download-modal-asset"
      >
        <Form>
          <div
            className="download-modal-asset-title"
          >
            {intl.formatMessage({ id: "download_asset" })}
          </div>
          {/* Asset view */}
          {
            !isBunker && <div className="download-modal-asset-fileview-wrapper">
              <p className="download-modal-asset-label">{`¿${intl.formatMessage({id: "download_drawer_question"})}: ${selectedFile.name}`}</p>
              <br/>
              <div
                className="download-modal-asset-view-wrapper"
              >
                {
                  selectedFile.type === 'image' && fileextension(selectedFile.originalURL) === 'svg'
                  && <SVGView comFromMiddleView={true} src={selectedFile.originalURL} assetId={selectedFile._id} />
                }
                {
                  selectedFile.type === 'image' && fileextension(selectedFile.originalURL) !== 'svg' &&
                  <img
                    alt={selectedFile.name}
                    src={selectedFile.mediaQualityURL}
                    className="download-modal-asset-img"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src="/images/extensions/image.png";
                      currentTarget.className="img-asset-list-error";
                    }}
                  />
                }
                {selectedFile.type === 'video' && <VideoView
                  url={selectedFile.lowQualityURL}
                  disableDefaultControls={false}
                  autoPlay={false}
                  muted={false}
                  divWidth = {300}
                  from="list"
                  />
                }
                {selectedFile.type === 'document' && <DocumentView
                  item={selectedFile}
                  from={`middleView`} />
                }
              </div>
            </div>
          }
        </Form>
        <div className='download-buttons' >
          {alreadyDownloading && <React.Fragment>
            <Tooltip title={alreadyDownloading ? intl.formatMessage({ id: "already_downloading_asset" }) : ''}>
              <Button
                onClick={() => this.handleOnDownload('original')}
                type="default"
                disabled={disabledBtnOriginal || alreadyDownloading}
                block>Original</Button>
            </Tooltip>
            {extValidate && <Tooltip title={alreadyDownloading ? intl.formatMessage({ id: "already_downloading_asset" }) : ''}>
              <Button
                disabled={alreadyDownloading}
                onClick={() => this.handleOnDownload('medium')}
                type="default"
                block>{intl.formatMessage({ id: "optimized_version" })}</Button>
            </Tooltip>}
            <Button
              style={{ color: newColor, borderColor: newColor, width: '100%' }}
              onClick={() => this.props.handleHiddenModal()}>{intl.formatMessage({ id: "cancel_button" })}</Button>
          </React.Fragment>}
          {!alreadyDownloading && <React.Fragment>
            <Tooltip
              title={!disabledBtnOriginal ? '' : intl.formatMessage({ id: "rights_asset_out" })}
              defaultVisible={!disabledBtnOriginal}>
              <Button
                onClick={() => this.handleOnDownload('original')}
                type="default"
                disabled={disabledBtnOriginal || alreadyDownloading}
                block>Original</Button>
            </Tooltip>
            {extValidate && <Button
              disabled={alreadyDownloading}
              onClick={() => this.handleOnDownload('medium')}
              type="default"
              block>{intl.formatMessage({ id: "optimized_version" })}</Button>}
            <Button
              style={{ color: newColor, borderColor: newColor, width: '100%' }}
              onClick={() => this.props.handleHiddenModal()}>{intl.formatMessage({ id: "cancel_button" })}</Button>
          </React.Fragment>}
        </div>
        {/* <Row type={"flex"} justify={"space-between"}>
          <Button
            size={"large"}
            type={"primary"}
            onClick={this.handleOnDownload}
            loading={isInFolderAction}
            className="download-modal-asset-button accept"
          >
            {intl.formatMessage({ id: "download_asset" })}
          </Button>
          <Button
            size={"large"}
            type={"primary"}
            ghost
            onClick={handleHiddenModal}
            className="download-modal-asset-button cancel"
          >
            {intl.formatMessage({ id: "cancel_button" })}
          </Button>
        </Row> */}
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    selectedFile: state.individualSelect.selectedFile,
    workclient: state.client.data ? state.client.data._id : null,
    isInFolderAction: state.client.isInFolderAction,
    dataDownload: state.downloads.data,
  };
};

const mapDispatchToProps = {
  startDownload,
  setkeyboardEnabled
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(DownloadModal))
);
